// extracted by mini-css-extract-plugin
module.exports = {"profileCardSkeleton":"profileV2ContentLoaders_profileCardSkeleton__D6HBn"};